const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "60px",
    height: "60px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#43443f",
    d: "M 0.5,-0.5 C 0.833333,-0.5 1.16667,-0.5 1.5,-0.5C 1.31468,0.170143 0.981346,0.170143 0.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#43443f",
    d: "M 2.5,-0.5 C 3.16667,-0.5 3.83333,-0.5 4.5,-0.5C 3.45227,1.93268 2.7856,1.93268 2.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#43443f",
    d: "M 7.5,-0.5 C 7.83333,-0.5 8.16667,-0.5 8.5,-0.5C 8.31468,0.170143 7.98135,0.170143 7.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#43433f",
    d: "M 14.5,-0.5 C 14.8333,-0.5 15.1667,-0.5 15.5,-0.5C 14.2464,2.09343 12.5798,4.42676 10.5,6.5C 10.1667,6.5 9.83333,6.5 9.5,6.5C 10.7536,3.90657 12.4202,1.57324 14.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#43433f",
    d: "M 21.5,-0.5 C 21.8333,-0.5 22.1667,-0.5 22.5,-0.5C 22.8333,0.833333 23.1667,0.833333 23.5,-0.5C 24.1667,-0.5 24.8333,-0.5 25.5,-0.5C 23.5,1.83333 21.5,4.16667 19.5,6.5C 19.1667,6.5 18.8333,6.5 18.5,6.5C 18.0825,5.77842 17.4158,5.27842 16.5,5C 18.3734,3.29617 20.0401,1.46283 21.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#43433f",
    d: "M 28.5,-0.5 C 29.8333,-0.5 31.1667,-0.5 32.5,-0.5C 30.8333,1.5 29.1667,3.5 27.5,5.5C 26.8333,5.5 26.5,5.83333 26.5,6.5C 26.1667,6.5 25.8333,6.5 25.5,6.5C 25.0825,5.77842 24.4158,5.27842 23.5,5C 25.3734,3.29617 27.0401,1.46283 28.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#43443f",
    d: "M 35.5,-0.5 C 36.1667,-0.5 36.8333,-0.5 37.5,-0.5C 36.8333,0.5 36.1667,1.5 35.5,2.5C 34.5768,3.30292 33.5768,3.46958 32.5,3C 33.7101,1.9609 34.7101,0.794229 35.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#43433f",
    d: "M 40.5,-0.5 C 40.8333,-0.5 41.1667,-0.5 41.5,-0.5C 41.8333,0.833333 42.1667,0.833333 42.5,-0.5C 43.1667,-0.5 43.8333,-0.5 44.5,-0.5C 43.6935,0.728127 42.6935,1.72813 41.5,2.5C 41.1667,2.5 40.8333,2.5 40.5,2.5C 39.7611,2.63101 39.0944,2.46434 38.5,2C 39.3805,1.2917 40.0472,0.458367 40.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#43443f",
    d: "M 45.5,-0.5 C 45.8333,-0.5 46.1667,-0.5 46.5,-0.5C 46.3147,0.170143 45.9813,0.170143 45.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#43433e",
    d: "M 47.5,-0.5 C 47.8333,-0.5 48.1667,-0.5 48.5,-0.5C 48.3147,0.170143 47.9813,0.170143 47.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#43443f",
    d: "M 49.5,-0.5 C 50.1667,-0.5 50.8333,-0.5 51.5,-0.5C 50.8333,0.833333 50.1667,0.833333 49.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#43423e",
    d: "M 56.5,-0.5 C 57.1667,-0.5 57.8333,-0.5 58.5,-0.5C 58.5,-0.166667 58.5,0.166667 58.5,0.5C 56.7541,2.25156 54.7541,3.58489 52.5,4.5C 53.8333,2.83333 55.1667,1.16667 56.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#43443f",
    d: "M -0.5,0.5 C -0.166667,0.5 0.166667,0.5 0.5,0.5C 0.31468,1.17014 -0.0186536,1.17014 -0.5,0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#43443f",
    d: "M 7.5,0.5 C 6.83333,1.16667 6.83333,1.16667 7.5,0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#43443f",
    d: "M 58.5,0.5 C 58.8333,0.5 59.1667,0.5 59.5,0.5C 59.5,0.833333 59.5,1.16667 59.5,1.5C 59.1667,1.16667 58.8333,0.833333 58.5,0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#43443f",
    d: "M 6.5,1.5 C 5.83333,2.16667 5.83333,2.16667 6.5,1.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.82
    },
    fill: "#8aa8b8",
    d: "M 52.5,4.5 C 52.5,5.16667 52.5,5.83333 52.5,6.5C 44.1667,6.5 35.8333,6.5 27.5,6.5C 27.1667,6.5 26.8333,6.5 26.5,6.5C 26.5,5.83333 26.8333,5.5 27.5,5.5C 30.8111,5.69283 33.4777,4.69283 35.5,2.5C 37.2837,3.71994 38.9504,3.71994 40.5,2.5C 40.8333,2.5 41.1667,2.5 41.5,2.5C 44.8067,1.9492 48.1401,1.61587 51.5,1.5C 51.2627,2.79105 51.596,3.79105 52.5,4.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#43443f",
    d: "M -0.5,2.5 C 1.93268,2.7856 1.93268,3.45227 -0.5,4.5C -0.5,3.83333 -0.5,3.16667 -0.5,2.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#43443f",
    d: "M 5.5,2.5 C 4.83333,3.16667 4.83333,3.16667 5.5,2.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#43443f",
    d: "M 59.5,2.5 C 59.5,2.83333 59.5,3.16667 59.5,3.5C 58.8299,3.01865 58.8299,2.68532 59.5,2.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#43443f",
    d: "M 4.5,3.5 C 3.83333,4.16667 3.83333,4.16667 4.5,3.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#43443f",
    d: "M 58.5,3.5 C 57.8333,4.16667 57.8333,4.16667 58.5,3.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#43443f",
    d: "M 3.5,4.5 C 2.83333,5.16667 2.83333,5.16667 3.5,4.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#43443f",
    d: "M 5.5,4.5 C 6.83333,5.16667 6.83333,5.16667 5.5,4.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#43443f",
    d: "M 7.5,4.5 C 8.83333,5.16667 8.83333,5.16667 7.5,4.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#43443f",
    d: "M 57.5,4.5 C 56.8333,5.16667 56.8333,5.16667 57.5,4.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#43443f",
    d: "M 2.5,5.5 C 2.5,5.83333 2.5,6.16667 2.5,6.5C 1.82986,6.01865 1.82986,5.68532 2.5,5.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#43443f",
    d: "M 59.5,5.5 C 59.5,5.83333 59.5,6.16667 59.5,6.5C 58.8299,6.01865 58.8299,5.68532 59.5,5.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#42433e",
    d: "M 1.5,6.5 C 0.833333,7.16667 0.833333,7.16667 1.5,6.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#43443f",
    d: "M 58.5,6.5 C 58.5,6.83333 58.5,7.16667 58.5,7.5C 57.8299,7.01865 57.8299,6.68532 58.5,6.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#43443f",
    d: "M -0.5,7.5 C -0.166667,7.5 0.166667,7.5 0.5,7.5C 0.31468,8.17014 -0.0186536,8.17014 -0.5,7.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#43443f",
    d: "M 58.5,7.5 C 58.8333,7.5 59.1667,7.5 59.5,7.5C 59.5,7.83333 59.5,8.16667 59.5,8.5C 59.1667,8.16667 58.8333,7.83333 58.5,7.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#40413c",
    d: "M 58.5,8.5 C 58.5,8.83333 58.5,9.16667 58.5,9.5C 57.8299,9.01865 57.8299,8.68532 58.5,8.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#3f403b",
    d: "M 0.5,9.5 C 1.83333,10.1667 1.83333,10.1667 0.5,9.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#42423e",
    d: "M 58.5,9.5 C 58.8333,9.5 59.1667,9.5 59.5,9.5C 59.5,10.1667 59.5,10.8333 59.5,11.5C 57.3023,11.5912 56.9689,10.9245 58.5,9.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c9d0d7",
    d: "M 56.5,5.5 C 56.5,12.8333 56.5,20.1667 56.5,27.5C 55.8008,34.3703 55.1341,41.3703 54.5,48.5C 55.2458,49.7362 55.5792,51.0695 55.5,52.5C 49.5,52.5 43.5,52.5 37.5,52.5C 37.1667,52.5 36.8333,52.5 36.5,52.5C 35.1667,52.5 33.8333,52.5 32.5,52.5C 23.8333,52.5 15.1667,52.5 6.5,52.5C 6.16667,52.5 5.83333,52.5 5.5,52.5C 21.1317,50.5152 37.1317,49.8486 53.5,50.5C 53.8287,37.6557 53.4954,24.989 52.5,12.5C 37.5364,10.5159 22.2031,9.84927 6.5,10.5C 6.5,20.5 6.5,30.5 6.5,40.5C 6.5,42.8333 6.5,45.1667 6.5,47.5C 5.50452,34.6774 5.17119,21.6774 5.5,8.5C 20.837,8.66659 36.1703,8.49992 51.5,8C 43.3228,7.82923 35.3228,7.32923 27.5,6.5C 35.8333,6.5 44.1667,6.5 52.5,6.5C 53.9587,6.56745 55.2921,6.23411 56.5,5.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#70b4e0",
    d: "M 51.5,41.5 C 49.1889,38.2331 46.8556,34.8998 44.5,31.5C 43.8333,31.1667 43.1667,30.8333 42.5,30.5C 40.7951,31.545 39.2951,32.8783 38,34.5C 35.9686,30.412 33.4686,26.7454 30.5,23.5C 29.8333,23.8333 29.1667,24.1667 28.5,24.5C 26,28.8333 23.5,33.1667 21,37.5C 19.6625,34.9979 17.8292,32.9979 15.5,31.5C 14.8333,31.6667 14.1667,31.8333 13.5,32C 11.636,34.6877 9.63604,37.1877 7.5,39.5C 7.5,30.1667 7.5,20.8333 7.5,11.5C 22.1667,11.5 36.8333,11.5 51.5,11.5C 51.5,21.5 51.5,31.5 51.5,41.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.844
    },
    fill: "#90acbc",
    d: "M -0.5,10.5 C -0.166667,10.5 0.166667,10.5 0.5,10.5C 0.841711,11.3382 1.50838,11.6716 2.5,11.5C 3.83333,18.1667 3.83333,24.8333 2.5,31.5C 2.16667,31.5 1.83333,31.5 1.5,31.5C 1.5,31.1667 1.5,30.8333 1.5,30.5C 1.76781,28.901 1.43448,27.5676 0.5,26.5C 0.784479,24.5853 0.451145,22.9187 -0.5,21.5C -0.5,17.8333 -0.5,14.1667 -0.5,10.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#43443f",
    d: "M 59.5,12.5 C 59.5,12.8333 59.5,13.1667 59.5,13.5C 58.8299,13.0187 58.8299,12.6853 59.5,12.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#99c2de",
    d: "M 52.5,12.5 C 52.5,22.5 52.5,32.5 52.5,42.5C 52.1667,42.5 51.8333,42.5 51.5,42.5C 51.5,42.1667 51.5,41.8333 51.5,41.5C 51.5,31.5 51.5,21.5 51.5,11.5C 36.8333,11.5 22.1667,11.5 7.5,11.5C 7.5,20.8333 7.5,30.1667 7.5,39.5C 7.5,39.8333 7.5,40.1667 7.5,40.5C 7.16667,40.5 6.83333,40.5 6.5,40.5C 6.5,30.5 6.5,20.5 6.5,10.5C 22.2031,9.84927 37.5364,10.5159 52.5,12.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#40403b",
    d: "M 58.5,13.5 C 58.5,13.8333 58.5,14.1667 58.5,14.5C 57.8299,14.0187 57.8299,13.6853 58.5,13.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#43443f",
    d: "M 58.5,14.5 C 58.8333,14.5 59.1667,14.5 59.5,14.5C 59.5,14.8333 59.5,15.1667 59.5,15.5C 59.1667,15.1667 58.8333,14.8333 58.5,14.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#40413c",
    d: "M 58.5,15.5 C 58.5,15.8333 58.5,16.1667 58.5,16.5C 57.8299,16.0187 57.8299,15.6853 58.5,15.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#43443f",
    d: "M 58.5,16.5 C 58.8333,16.5 59.1667,16.5 59.5,16.5C 59.5,16.8333 59.5,17.1667 59.5,17.5C 59.1667,17.1667 58.8333,16.8333 58.5,16.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#40403b",
    d: "M 58.5,17.5 C 57.8333,18.1667 57.8333,18.1667 58.5,17.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#43443f",
    d: "M 59.5,19.5 C 59.5,19.8333 59.5,20.1667 59.5,20.5C 58.8299,20.0187 58.8299,19.6853 59.5,19.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#3f403b",
    d: "M 58.5,20.5 C 58.5,20.8333 58.5,21.1667 58.5,21.5C 57.8299,21.0187 57.8299,20.6853 58.5,20.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#43443f",
    d: "M 58.5,21.5 C 58.8333,21.5 59.1667,21.5 59.5,21.5C 59.5,21.8333 59.5,22.1667 59.5,22.5C 59.1667,22.1667 58.8333,21.8333 58.5,21.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#40413c",
    d: "M 58.5,22.5 C 58.5,22.8333 58.5,23.1667 58.5,23.5C 57.8299,23.0187 57.8299,22.6853 58.5,22.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#42423e",
    d: "M 58.5,23.5 C 58.8333,23.5 59.1667,23.5 59.5,23.5C 59.5,24.1667 59.5,24.8333 59.5,25.5C 57.3023,25.5912 56.9689,24.9245 58.5,23.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#3f3f3a",
    d: "M -0.5,26.5 C -0.166667,26.5 0.166667,26.5 0.5,26.5C 0.31468,27.1701 -0.0186536,27.1701 -0.5,26.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#43443f",
    d: "M 59.5,26.5 C 59.5,26.8333 59.5,27.1667 59.5,27.5C 58.8299,27.0187 58.8299,26.6853 59.5,26.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#3f3e39",
    d: "M -0.5,28.5 C 0.166667,29.1667 0.833333,29.8333 1.5,30.5C 1.5,30.8333 1.5,31.1667 1.5,31.5C 0.833333,31.8333 0.166667,32.1667 -0.5,32.5C -0.5,31.1667 -0.5,29.8333 -0.5,28.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#43443f",
    d: "M 59.5,28.5 C 59.5,28.8333 59.5,29.1667 59.5,29.5C 58.8299,29.0187 58.8299,28.6853 59.5,28.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#413f3b",
    d: "M 59.5,30.5 C 59.5,31.1667 59.5,31.8333 59.5,32.5C 59.1667,32.5 58.8333,32.5 58.5,32.5C 58.3284,31.5084 58.6618,30.8417 59.5,30.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.842
    },
    fill: "#90abba",
    d: "M 56.5,27.5 C 57.1667,29.1667 57.8333,30.8333 58.5,32.5C 58.2155,34.4147 58.5489,36.0813 59.5,37.5C 59.5,41.1667 59.5,44.8333 59.5,48.5C 56.4451,47.9092 55.7785,49.2425 57.5,52.5C 56.8333,52.5 56.5,52.8333 56.5,53.5C 55.8333,53.5 55.5,53.1667 55.5,52.5C 55.5792,51.0695 55.2458,49.7362 54.5,48.5C 55.1341,41.3703 55.8008,34.3703 56.5,27.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#42423e",
    d: "M -0.5,37.5 C -0.5,36.8333 -0.5,36.1667 -0.5,35.5C 2.18674,34.9394 2.18674,35.6061 -0.5,37.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#42423e",
    d: "M -0.5,44.5 C -0.5,43.8333 -0.5,43.1667 -0.5,42.5C 2.18674,41.9394 2.18674,42.6061 -0.5,44.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dbdee1",
    d: "M 2.5,6.5 C 4.83333,6.5 7.16667,6.5 9.5,6.5C 9.83333,6.5 10.1667,6.5 10.5,6.5C 13.1667,6.5 15.8333,6.5 18.5,6.5C 18.8333,6.5 19.1667,6.5 19.5,6.5C 21.5,6.5 23.5,6.5 25.5,6.5C 25.8333,6.5 26.1667,6.5 26.5,6.5C 26.8333,6.5 27.1667,6.5 27.5,6.5C 35.3228,7.32923 43.3228,7.82923 51.5,8C 36.1703,8.49992 20.837,8.66659 5.5,8.5C 5.17119,21.6774 5.50452,34.6774 6.5,47.5C 21.6576,48.4962 36.9909,48.8295 52.5,48.5C 52.5,46.5 52.5,44.5 52.5,42.5C 52.5,32.5 52.5,22.5 52.5,12.5C 53.4954,24.989 53.8287,37.6557 53.5,50.5C 37.1317,49.8486 21.1317,50.5152 5.5,52.5C 4.5,52.5 3.5,52.5 2.5,52.5C 2.5,45.5 2.5,38.5 2.5,31.5C 3.83333,24.8333 3.83333,18.1667 2.5,11.5C 2.5,9.83333 2.5,8.16667 2.5,6.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#81919d",
    d: "M 6.5,40.5 C 6.83333,40.5 7.16667,40.5 7.5,40.5C 7.5,42.8333 7.5,45.1667 7.5,47.5C 22.1667,47.5 36.8333,47.5 51.5,47.5C 51.5,45.8333 51.5,44.1667 51.5,42.5C 51.8333,42.5 52.1667,42.5 52.5,42.5C 52.5,44.5 52.5,46.5 52.5,48.5C 36.9909,48.8295 21.6576,48.4962 6.5,47.5C 6.5,45.1667 6.5,42.8333 6.5,40.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#536a7c",
    d: "M 51.5,41.5 C 51.5,41.8333 51.5,42.1667 51.5,42.5C 51.5,44.1667 51.5,45.8333 51.5,47.5C 36.8333,47.5 22.1667,47.5 7.5,47.5C 7.5,45.1667 7.5,42.8333 7.5,40.5C 7.5,40.1667 7.5,39.8333 7.5,39.5C 9.63604,37.1877 11.636,34.6877 13.5,32C 14.1667,31.8333 14.8333,31.6667 15.5,31.5C 17.8292,32.9979 19.6625,34.9979 21,37.5C 23.5,33.1667 26,28.8333 28.5,24.5C 29.1667,24.1667 29.8333,23.8333 30.5,23.5C 33.4686,26.7454 35.9686,30.412 38,34.5C 39.2951,32.8783 40.7951,31.545 42.5,30.5C 43.1667,30.8333 43.8333,31.1667 44.5,31.5C 46.8556,34.8998 49.1889,38.2331 51.5,41.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bdb385",
    d: "M 21.5,20.5 C 21.0291,21.9008 20.3624,23.2342 19.5,24.5C 18.8933,24.3764 18.56,24.0431 18.5,23.5C 19.1001,22.0998 20.1001,21.0998 21.5,20.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#eef5fa",
    d: "M 42.5,19.5 C 44.6648,19.1159 46.3315,19.7826 47.5,21.5C 45.5,22.8333 43.5,22.8333 41.5,21.5C 41.8627,20.8165 42.1961,20.1499 42.5,19.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e3b359",
    d: "M 20.5,19.5 C 18.5441,17.8516 16.2108,17.1849 13.5,17.5C 13.7095,20.2651 15.0429,22.2651 17.5,23.5C 16.88,25.9767 15.88,25.9767 14.5,23.5C 13.914,23.7093 13.414,24.0426 13,24.5C 11.6647,21.7763 11.498,19.1096 12.5,16.5C 14.143,16.5198 15.4763,15.8532 16.5,14.5C 17.5237,15.8532 18.857,16.5198 20.5,16.5C 20.5,17.5 20.5,18.5 20.5,19.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f2b344",
    d: "M 20.5,19.5 C 21.1667,19.5 21.5,19.8333 21.5,20.5C 20.1001,21.0998 19.1001,22.0998 18.5,23.5C 18.1667,23.5 17.8333,23.5 17.5,23.5C 15.0429,22.2651 13.7095,20.2651 13.5,17.5C 16.2108,17.1849 18.5441,17.8516 20.5,19.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e6f1f8",
    d: "M 34.5,16.5 C 37.5,16.1667 38.8333,17.5 38.5,20.5C 36.5,20.5 34.5,20.5 32.5,20.5C 32.5271,18.8007 33.1938,17.4674 34.5,16.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#42423e",
    d: "M -0.5,51.5 C -0.5,50.8333 -0.5,50.1667 -0.5,49.5C 2.18674,48.9394 2.18674,49.6061 -0.5,51.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#43443f",
    d: "M 59.5,51.5 C 59.5,52.1667 59.5,52.8333 59.5,53.5C 58.8333,53.5 58.5,53.8333 58.5,54.5C 56.8333,55.5 55.5,56.8333 54.5,58.5C 53.8333,58.5 53.5,58.8333 53.5,59.5C 52.8333,59.5 52.1667,59.5 51.5,59.5C 53.1667,57.5 54.8333,55.5 56.5,53.5C 57.1667,53.5 57.5,53.1667 57.5,52.5C 58.1667,52.1667 58.8333,51.8333 59.5,51.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#43443f",
    d: "M 0.5,58.5 C 0.166667,58.5 -0.166667,58.5 -0.5,58.5C -0.5,57.8333 -0.5,57.1667 -0.5,56.5C 0.89793,54.8912 2.5646,54.0579 4.5,54C 2.95862,55.3712 1.62529,56.8712 0.5,58.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#43433e",
    d: "M 36.5,52.5 C 36.8333,52.5 37.1667,52.5 37.5,52.5C 36.5849,54.7541 35.2516,56.7541 33.5,58.5C 32.8333,58.5 32.5,58.8333 32.5,59.5C 31.8333,59.5 31.1667,59.5 30.5,59.5C 32.5,57.1667 34.5,54.8333 36.5,52.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#43443f",
    d: "M 42.5,58.5 C 41.8333,58.5 41.5,58.8333 41.5,59.5C 41.1667,59.5 40.8333,59.5 40.5,59.5C 40.1667,58.1667 39.8333,58.1667 39.5,59.5C 38.8333,59.5 38.1667,59.5 37.5,59.5C 39.4456,55.6832 42.4456,53.8499 46.5,54C 44.9586,55.3712 43.6253,56.8712 42.5,58.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#43443f",
    d: "M 49.5,58.5 C 48.8333,58.5 48.5,58.8333 48.5,59.5C 48.1667,59.5 47.8333,59.5 47.5,59.5C 47.1667,58.1667 46.8333,58.1667 46.5,59.5C 45.8333,59.5 45.1667,59.5 44.5,59.5C 46.4456,55.6832 49.4456,53.8499 53.5,54C 51.9586,55.3712 50.6253,56.8712 49.5,58.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.671
    },
    fill: "#819eae",
    d: "M 6.5,52.5 C 15.1667,52.5 23.8333,52.5 32.5,52.5C 32.4173,54.5695 31.4173,54.9028 29.5,53.5C 26.8853,53.6836 24.7186,54.6836 23,56.5C 21.3845,55.1991 19.8845,55.1991 18.5,56.5C 17.8333,56.5 17.5,56.8333 17.5,57.5C 14.2842,57.0164 10.9509,57.0164 7.5,57.5C 7.37133,55.7839 7.038,54.1172 6.5,52.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#43443f",
    d: "M 58.5,54.5 C 58.8333,54.5 59.1667,54.5 59.5,54.5C 59.5,54.8333 59.5,55.1667 59.5,55.5C 59.1667,55.1667 58.8333,54.8333 58.5,54.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#42433e",
    d: "M 5.5,55.5 C 6.83333,56.1667 6.83333,56.1667 5.5,55.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#43443f",
    d: "M 5.5,56.5 C 4.83333,57.1667 4.83333,57.1667 5.5,56.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#43443f",
    d: "M 18.5,56.5 C 19.8333,57.1667 19.8333,57.1667 18.5,56.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#43443f",
    d: "M 59.5,56.5 C 59.5,57.1667 59.5,57.8333 59.5,58.5C 58.8333,58.5 58.5,58.8333 58.5,59.5C 57.8333,59.5 57.1667,59.5 56.5,59.5C 57.1667,58.1667 58.1667,57.1667 59.5,56.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#43443f",
    d: "M 4.5,57.5 C 3.83333,58.1667 3.83333,58.1667 4.5,57.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#43443f",
    d: "M 7.5,57.5 C 7.5,57.8333 7.5,58.1667 7.5,58.5C 6.82986,58.0187 6.82986,57.6853 7.5,57.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#43443f",
    d: "M 17.5,57.5 C 17.8333,57.5 18.1667,57.5 18.5,57.5C 18.3147,58.1701 17.9813,58.1701 17.5,57.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#43443f",
    d: "M 25.5,59.5 C 24.8333,59.5 24.1667,59.5 23.5,59.5C 24.5477,57.0673 25.2144,57.0673 25.5,59.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#43443f",
    d: "M 0.5,58.5 C 1.16667,58.5 1.5,58.8333 1.5,59.5C 1.16667,59.1667 0.833333,58.8333 0.5,58.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#43443f",
    d: "M 3.5,58.5 C 3.5,58.8333 3.5,59.1667 3.5,59.5C 2.82986,59.0187 2.82986,58.6853 3.5,58.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#43443f",
    d: "M 6.5,58.5 C 6.5,58.8333 6.5,59.1667 6.5,59.5C 5.82986,59.0187 5.82986,58.6853 6.5,58.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#43443f",
    d: "M 7.5,58.5 C 8.16667,58.5 8.5,58.8333 8.5,59.5C 8.16667,59.1667 7.83333,58.8333 7.5,58.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#44433f",
    d: "M 9.5,59.5 C 10.1667,58.1667 10.8333,58.1667 11.5,59.5C 10.8333,59.5 10.1667,59.5 9.5,59.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#43443f",
    d: "M 13.5,59.5 C 12.8333,58.1667 12.8333,58.1667 13.5,59.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#43443f",
    d: "M 17.5,58.5 C 17.5,58.8333 17.5,59.1667 17.5,59.5C 16.8299,59.0187 16.8299,58.6853 17.5,58.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#43443f",
    d: "M 20.5,59.5 C 19.8333,58.1667 19.8333,58.1667 20.5,59.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#43443f",
    d: "M 22.5,59.5 C 21.8333,58.1667 21.8333,58.1667 22.5,59.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#43443f",
    d: "M 27.5,59.5 C 26.8333,58.1667 26.8333,58.1667 27.5,59.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#43443f",
    d: "M 29.5,59.5 C 28.8333,58.1667 28.8333,58.1667 29.5,59.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#43443f",
    d: "M 33.5,58.5 C 34.1667,58.5 34.5,58.8333 34.5,59.5C 34.1667,59.1667 33.8333,58.8333 33.5,58.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#43443f",
    d: "M 36.5,59.5 C 35.8333,58.1667 35.8333,58.1667 36.5,59.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#43443f",
    d: "M 42.5,58.5 C 43.1667,58.5 43.5,58.8333 43.5,59.5C 43.1667,59.1667 42.8333,58.8333 42.5,58.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#43443f",
    d: "M 49.5,58.5 C 50.1667,58.5 50.5,58.8333 50.5,59.5C 50.1667,59.1667 49.8333,58.8333 49.5,58.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#43443f",
    d: "M 54.5,58.5 C 55.1667,58.5 55.5,58.8333 55.5,59.5C 55.1667,59.1667 54.8333,58.8333 54.5,58.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg);
export default __webpack_public_path__ + "static/media/img.d7d96bf6a13e5bed646d0f03a6b08344.svg";
export { ForwardRef as ReactComponent };